export const PARENT_PORTFOLIO_CONTENT = {
  parentPortfolio: 'Parent Portfolio',
  parentPortfolios: 'Parent Portfolios',
  parentPortfolioInfo: 'Portfolio Info',
  parentPortfolioName: 'Portfolio Name',
  parentPortfolioMilestone: 'Portfolio Milestone',
  parentPortfolioMilestones: 'Portfolio Milestones',
  parentPortfolioProjects: 'Portfolio Projects',
  numberProjects: 'Number of projects',

  parentPortfolioLabels: {
    title: 'Title of the parent portfolio',
  },

  deleteParentPortfolio: 'Delete Parent Portfolio',
  deleteParentPortfolioDescription:
    'Are you sure you want to delete this parent portfolio? Child portfolios that roll up to this parent portfolio will not be deleted.',
};
